// const DashboardLayout = () => import(/* webpackChunkName: "DashboardLayout" */ '../layout/DashboardLayout.vue')
// const PublicLayout = () => import(/* webpackChunkName: "PublicLayout" */ '../layout/PublicLayout.vue')
import DashboardLayout from '../layout/DashboardLayout.vue'
import PublicLayout from '../layout/PublicLayout.vue'

// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'
import LoginPage from '../pages/Auth/LoginPage.vue'
import SignUpPage from '../pages/Auth/SignUpPage.vue'
import NYI from '../pages/NYI.vue'
// const NYI = () => import(/* webpackChunkName: "NYI" */ 'src/pages/NYI.vue')
// const LoginPage = () => import(/* webpackChunkName: "LoginPage" */ '../pages/Auth/LoginPage.vue')
// const SignUpPage = () => import(/* webpackChunkName: "SignUpPage" */ '../pages/Auth/SignUpPage.vue')

// Admin pages
// const AdminImport = () => import(/* webpackChunkName: "AdminImport" */ 'src/pages/AdminImport.vue')
// const Overview = () => import('src/pages/Overview.vue')
const AdminBalanceList = () => import(/* webpackChunkName: "AdminBalanceList" */ 'src/pages/Finance/AdminBalanceList.vue')
const AdminBannerList = () => import(/* webpackChunkName: "AdminBannerList" */ 'src/pages/Banner/BannerList.vue')
const AdminBannerView = () => import(/* webpackChunkName: "AdminBannerView" */ 'src/pages/Banner/BannerView.vue')
const AdminExchangeRateList = () => import(/* webpackChunkName: "AdminExchangeRateList" */ 'src/pages/Finance/AdminExchangeRateList.vue')
const AdminPayoutList = () => import(/* webpackChunkName: "AdminPayoutList" */ 'src/pages/Finance/AdminPayoutList.vue')
const AdminPayoutEdit = () => import(/* webpackChunkName: "AdminPayoutEdit" */ 'src/pages/Finance/AdminPayoutEdit.vue')
const AdminTransferList = () => import(/* webpackChunkName: "AdminTransferList" */ 'src/pages/Finance/AdminTransferList.vue')
const AdminTransferView = () => import(/* webpackChunkName: "AdminTransferView" */ 'src/pages/Finance/AdminTransferView.vue')

// Cause
const CauseList = () => import(/* webpackChunkName: "CauseList" */ 'src/pages/Cause/CauseList.vue')
const CauseView = () => import(/* webpackChunkName: "CauseView" */ 'src/pages/Cause/CauseView.vue')
// Finance
const BalanceList = () => import(/* webpackChunkName: "BalanceList" */ 'src/pages/Finance/BalanceList.vue')
const PaymentList = () => import(/* webpackChunkName: "PaymentList" */ 'src/pages/Finance/PaymentList.vue')
const PaymentView = () => import(/* webpackChunkName: "PaymentView" */ 'src/pages/Finance/PaymentView.vue')
const PayoutList = () => import(/* webpackChunkName: "PayoutList" */ 'src/pages/Finance/PayoutList.vue')
const PayoutView = () => import(/* webpackChunkName: "PayoutView" */ 'src/pages/Finance/PayoutView.vue')
const RecurringList = () => import(/* webpackChunkName: "RecurringList" */ 'src/pages/Finance/RecurringList.vue')
const RecurringView = () => import(/* webpackChunkName: "RecurringView" */ 'src/pages/Finance/RecurringView.vue')
// Settings
const BankAccountList = () => import(/* webpackChunkName: "BankAccountList" */ 'src/pages/Finance/BankAccountList.vue')
const BankAccountView = () => import(/* webpackChunkName: "BankAccountView" */ 'src/pages/Finance/BankAccountView.vue')
const OrganizationList = () => import(/* webpackChunkName: "OrganizationList" */ 'src/pages/Organization/OrganizationList.vue')
const OrganizationView = () => import(/* webpackChunkName: "OrganizationView" */ 'src/pages/Organization/OrganizationView.vue')
const SettingsOrganization = () => import(/* webpackChunkName: "SettingsOrganization" */ 'src/pages/Organization/SettingsOrganization.vue')
const UserList = () => import(/* webpackChunkName: "UserList" */ 'src/pages/User/UserList.vue')
const UserView = () => import(/* webpackChunkName: "UserView" */ 'src/pages/User/UserView.vue')
const UserViewAdmin = () => import(/* webpackChunkName: "UserViewAdmin" */ 'src/pages/User/UserViewAdmin.vue')

function prefixRoutes(prefix, r) {
  r.forEach(route => route.path = prefix + '/' + route.path)
  return r
}

const routes = [
  {
    path: '/',
    redirect: '/me/cause/list',
  },
  {
    path: '/me/auth',
    component: PublicLayout,
    meta: {
      guest: true
    },
    children: [
      {
        path: 'login',
        component: LoginPage,
        meta: {
          guest: true
        }
      },
      {
        path: 'signup',
        component: SignUpPage,
        meta: {
          guest: true
        }
      },
      // {
      //   path: ':category(gift|memorial|cause|project)/:cause(\\w+)',
      //   component: NYI
      // }
    ]
  },
  {
    path: '/me',
    component: DashboardLayout,
    redirect: '/me/cause/list',
    meta: {
      requiresAuth: true
    },
    children: [
      // {
      //   path: 'overview',
      //   name: 'Dashboard',
      //   component: Overview
      // },
      {
        path: 'cause/list',
        name: 'CauseList',
        component: CauseList
      },
      {
        path: 'cause/:causeId',
        name: 'CauseView',
        component: CauseView
      },
      {
        path: 'profile',
        name: 'Profile',
        component: UserView
      },
      ...prefixRoutes('finance', [
        {
          path: 'donations/list',
          name: 'DonationList',
          component: NYI
        },
        {
          path: 'payment/list',
          name: 'PaymentList',
          component: PaymentList
        },
        {
          path: 'payment/:paymentId',
          name: 'PaymentView',
          component: PaymentView
        },
        {
          path: 'recurring/list',
          name: 'RecurringList',
          component: RecurringList
        },
        {
          path: 'recurring/:recurringId',
          name: 'RecurringView',
          component: RecurringView
        },
        {
          path: 'balance/list',
          name: 'BalanceList',
          component: BalanceList
        },
        {
          path: 'payout/list',
          name: 'PayoutList',
          component: PayoutList
        },
        {
          path: 'payout/:payoutId',
          name: 'PayoutView',
          component: PayoutView
        }
      ]),
      ...prefixRoutes('settings', [
        {
          path: 'organization',
          name: 'SettingsOrganizations',
          component: SettingsOrganization
        },
        {
          path: 'bank/list',
          name: 'BankAccountList',
          component: BankAccountList
        },
        {
          path: 'bank/:bankAccountId',
          name: 'BankAccountView',
          component: BankAccountView
        },
        {
          path: 'verify',
          name: 'Verify',
          component: NYI
        },
      ]),
      ...prefixRoutes('admin', [
        {
          path: 'balance/list',
          name: 'AdminBalanceList',
          component: AdminBalanceList
        },
        {
          path: 'banner/list',
          name: 'AdminBannerList',
          component: AdminBannerList
        },
        {
          path: 'banner/:bannerId',
          name: 'AdminBannerView',
          component: AdminBannerView
        },
        {
          path: 'exchangerate/list',
          name: 'AdminExchangeRateList',
          component: AdminExchangeRateList
        },
        {
          path: 'payout/list',
          name: 'AdminPayoutList',
          component: AdminPayoutList
        },
        {
          path: 'payout/:payoutId',
          name: 'AdminPayoutEdit',
          component: AdminPayoutEdit
        },
        {
          path: 'transfer/list',
          name: 'AdminTransferList',
          component: AdminTransferList
        },
        {
          path: 'transfer/:transferId',
          name: 'AdminTransferView',
          component: AdminTransferView
        },
        {
          path: 'organization/list',
          name: 'OrganizationList',
          component: OrganizationList
        },
        {
          path: 'organization/:organizationId',
          name: 'OrganizationView',
          component: OrganizationView
        },
        {
          path: 'user/list',
          name: 'UserList',
          component: UserList
        },
        {
          path: 'user/:userId',
          name: 'UserViewAdmin',
          component: UserViewAdmin
        },
      ])
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
